import styles from './ThreeColumn.module.scss'
import { ReactNode } from "react";

export default (
  {
    columns,
    noBorder = false,
    stretch = false,
  }: {
    columns: ReactNode[]
    noBorder?: boolean
    // full width cards when stacked on mobile
    stretch?: boolean
  }) => {
  return <div className={[styles.columns, noBorder && styles.noBorder, stretch && styles.stretch].join(' ')}>
    {columns.map((column, index) => <div key={index}>{column}</div>)}
  </div>
}